import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { SelectionItem } from '../../../core/component/select/select.component';
import { CdkDragDrop } from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-sort-form',
    templateUrl: './sort-form.component.html',
    styleUrls: ['./sort-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SortFormComponent implements OnInit {
  constructor(private _modalService: ActionWindowService) {}

  ngOnInit() {
    this.orderedItems = [];
    for (let item of this.dataContext.items) this.orderedItems.push(item);
  }

  @Input() dataContext: {
    items: SelectionItem[];
    title: string;
  };
  orderedItems: SelectionItem[];

  onSubmit() {
    this._modalService.complete({ dataContext: this.orderedItems });
  }

  drop(event: CdkDragDrop<string[]>) {
    const movedItem = this.orderedItems[event.previousIndex];
    this.orderedItems.splice(event.previousIndex, 1);
    this.orderedItems.splice(event.currentIndex, 0, movedItem);
  }
}
